export const getHeaders = () => {
  return {
    'Content-Type': 'application/json'
  }
}

export const getBase = () => {
  const apiBaseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:4000'
  return apiBaseUrl
}

export const getWebBase = () => {
  const apiBaseUrl = process.env.REACT_APP_WEB_BASE_URL || `https://mediamodifier.com`
  return apiBaseUrl
}